import { useMemo } from "react";
import { useShallow } from "zustand/shallow";
import { openTimeByGroup } from "../../store/config";
import { usePairs } from "../../store/pairs";
import { checkIsClosed } from "../../utils/time";

export function useCheckClosePair(pairIndex: number) {
  const pairs = usePairs(useShallow((state) => state.data));
  const groupName = useMemo(() => {
    return pairs.find((item) => item.pairIndex === pairIndex)?.groupName;
  }, [pairIndex, pairs]);

  const isClose = useMemo(() => {
    if (!groupName) {
      return false;
    }

    if (!openTimeByGroup[groupName]) {
      return false;
    }

    return checkIsClosed(groupName, openTimeByGroup[groupName]);
  }, [groupName]);
  return { isClose };
}
